import React from 'react'

const Followers = ()=>{
    return(
        <div>
            Following
        </div>
    )
    }
export default Followers